import React, { FunctionComponent, memo } from "react";
import { IconDimension } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { File, getFileIcon } from "@smartsuite/types";
import { noop } from "lodash-es";

interface FilePreviewIconProps {
  file: File;
  dimension: IconDimension;
  onClick?: (event: React.MouseEvent) => void;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
}

const FilePreviewIconRaw: FunctionComponent<FilePreviewIconProps> = ({
  file,
  dimension,
  onClick,
  onMouseEnter,
  onMouseLeave,
}): JSX.Element => {
  const icon = getFileIcon(file);
  const title = file.metadata.filename;

  return (
    <div
      role="button"
      tabIndex={0}
      style={{
        ...dimension,
        minWidth: dimension.width,
        backgroundImage: `url("/images/filetypes/${icon}.svg")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "var(--file-preview-icon-background-size, cover)",
      }}
      aria-label={title}
      onClick={onClick}
      onKeyDown={(_event) => noop}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

export const FilePreviewIcon = memo(FilePreviewIconRaw);
